<header>
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Administración Información - Crear Novedad CHV</h5>
    </div>
    <div class="card-body">
      <div class="row" style="margin-top: 3px;">
        <div class="col-auto" style="text-align: center;">
          <button type="button" class="btn btn-secondary" (click)="RegresarAdminChv()">Volver</button>
        </div>
        <!--div class="col-1" style="text-align: center;">
          <label style="margin-top: 4px;"><b>Periodo :</b></label>
        </div>
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="periodo" (change)="CosultarListaEstados($event.target.value)">
            <option  value="" selected="selected">Seleccionar</option>
            <option *ngFor="let p of PeriodosConsultar" value="{{p.id}}">{{p.anio}} - {{p.consecutivoPeriodo}}</option>
          </select>
        </div-->
        <div class="col-1" style="text-align: center;">
          <label style="margin-top: 4px;"><b>Periodo :</b></label>
        </div>
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="anio" (change)="CosultarListaEstados()" [(ngModel)]="anioConsulta"><!--     [disabled]="btnGuardar"-->
            <option  value="PeriodoSeleccionado.anio" selected="selected">Seleccionar</option>
            <option *ngFor="let p of aniosVigen" value="{{p}}">{{p}}</option>
          </select>
        </div>
        <div class="col-auto">
          <label for=""><b>-</b></label>
        </div>
        <div class="col-auto">
          <select class="form-select" aria-label="Default select example" name="trimestre" (change)="CosultarListaEstados()" [(ngModel)]="consucutivoConsulta" ><!-- [(ngModel)]="PeriodoConsulta"   [disabled]="btnGuardar"-->
            <option value="" selected="selected">Seleccionar</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
          </select>
        </div>
      </div>
      <div id="tabla" class="container-fluid overflow-scroll">
        <table datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger" class="table table-bordered row-border hover datatable"
           id="table2excel">
          <thead>
            <tr>
              <th scope="col" class="text-center">Periodo</th>
              <th scope="col" class="text-center">NIT</th>
              <th scope="col" class="text-center">Razón social</th>
              <th scope="col" class="text-center">Departamento</th>
              <th scope="col" class="text-center">Municipio</th>
              <th scope="col" class="text-center">Estado cargue</th>
              <th scope="col" class="text-center">Estado fuente</th>
              <th scope="col" class="text-center">Novedad</th>
              <th scope="col" class="text-center">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let L of ListaEstadosFuentes">
              <td scope="col" >{{L.perido}}</td>
              <td scope="col" >{{L.nit}}</td>
              <td scope="col" >{{L.razonSocial}}</td>
              <td scope="col" class="text-center">{{L.depto}}</td>
              <td scope="col" class="text-center">{{L.muni}}</td>
              <td scope="col" class="text-center">{{L.estadocargue}}</td>
              <td scope="col" class="text-center">{{L.estadofuente}}</td>
              <td scope="col" >{{L.novedad}}</td>
              <td scope="col" class="text-center">
                <i class="fa-solid fa-memo-circle-check"></i>
                <a type="button" class="fa fa-indent" style="color: green;  margin: 3px;" data-bs-toggle="tooltip" title="Asignar" (click)="ConfirmarCrearNovedad(L.idEstInf)"></a>
                <a type="button" class="fa fa-calendar-check" style="color: blue;  margin: 3px; margin-left: 7px;" data-bs-toggle="tooltip" title="Ver" (click)="VerNovedad(L.idEstInf)"></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</body>

<!--Confirmar crear novedad para fuente-->
<button class="btn btn-primary btn-sm" #openmodalconfirmar data-toggle="modal"  data-target="#confirmar" style="visibility: hidden;" data-backdrop="static">Modal</button>
<div class="modal fade bd-example-modal-md" id="confirmar" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">Confirmar</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="container-fluid">
          <div *ngIf="(EstadoInformacionSelect.novedadUsu=='0. Pendiente')" class="row" style="text-align: center;">
            <p>No existe novedad para el reporte de la <b>{{Fuente.nombEntidad}}</b> en el periodo <b>{{PeriodoModalNovedad}}</b>, ¿confirma que desea crear una nueva?</p>
          </div>
          <div *ngIf="(EstadoInformacionSelect.novedadUsu!='0. Pendiente')" class="row" style="text-align: center;">
            <p>Existe novedad para el reporte de la <b>{{Fuente.nombEntidad}}</b> en el periodo <b>{{PeriodoModalNovedad}}</b>, ¿confirma que desea asignar nuevamente una novedad?</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" #closemodalconfirmar data-dismiss="modal">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="AsignarNovedad()">Confirmar</button>
      </div>
    </div>
  </div>
</div>

<!--Asignar novedad a la fuente-->
<button class="btn btn-primary btn-sm" #openmodalcrearnovedad data-toggle="modal"  data-target="#crearnovedad" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-xl" id="crearnovedad" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">Crear novedad</h4>
        <button type="button" class="close"  aria-label="Close" data-dismiss="modal"><!---->
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row" style="margin: 5px;">
            <div class="col-6">
              <div class="row"><b>Razón social</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="razonsocialfichaind" [(ngModel)]="Fuente.nombEntidad" disabled/></div>
            </div>
            <div class="col-2">
              <div class="row"><b>NIT</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="nit" [(ngModel)]="Fuente.nit" disabled/></div><!---->
            </div>
            <div class="col-2">
              <div class="row"><b>Código entidad</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="codigoenti" [(ngModel)]="Fuente.codEnti" disabled/></div><!---->
            </div>
            <div class="col-2">
              <div class="row"><b>Periodo</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="periodo" [(ngModel)]="PeriodoModalNovedad" disabled/></div><!---->
            </div>
          </div>
          <div class="row" style="margin-top: 10px;  margin-left: 10px;">
            <div class="col-2">
                <b>Tipo de novedad :</b>
            </div>
            <div class="col-3">
                <select class="form-select" aria-label="Default select example" name="tiponovedad" [(ngModel)]="TipoNovNueva">
                    <option  value="" selected="selected">Seleccione</option>
                    <option  value="1. Adquisición">1. Adquisición</option>
                    <option  value="2. Cesion de activos, pasivos y contratos">2. Cesion de activos, pasivos y contratoss</option>
                    <option  value="3. Constitución">3. Constitución</option>
                    <option  value="4. Conversión">4. Conversión</option>
                    <option  value="5. Disolución – Liquidación">5. Disolución – Liquidación</option>
                    <option  value="6. Disolución – Sin liquidación">6. Disolución – Sin liquidación</option>
                    <option  value="7. Escisión">7. Escisión</option>
                    <option  value="8. Fusión">8. Fusión</option>
                    <option  value="9. Liquidación Forzosa administrativa">9. Liquidación Forzosa administrativa</option>
                    <option  value="10. Liquidación voluntaria">10. Liquidación voluntaria</option>
                    <option  value="11. Toma de posesión Ley 510 de 1999">11. Toma de posesión Ley 510 de 1999</option>
                    <option  value="12. Transformación">12. Transformación</option>
                    <option  value="13. Cambio de tipo de entidad">13. Cambio de tipo de entidad</option>
                    <option  value="14. Certificado de No Movimiento">14. Certificado de No Movimiento</option>
                    <option  value="15. No Aplica">15. No Aplica</option>
                </select>
            </div>
          </div>
          <div>
            <div class="row" style="margin-top: 3px; margin-left: 10px;">
              <b>Observación: </b>
            </div>
            <div style="text-align: center;">
               <textarea class="form-control col-11" name="observacionaprobador" rows="4" style="margin: auto; margin-top: 3px;" [(ngModel)]="ObserNovNueva" maxlength="255"></textarea><!---->
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" #closemodalcrearnovedad>Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="GuardarNovedad()" [disabled]="BtnCrearNov">Crear</button>
      </div>
    </div>
  </div>
</div>

<!--Ver novedades-->
<button class="btn btn-primary btn-sm" #openmodalvernovedad data-toggle="modal"  data-target="#vernovedad" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-xl" id="vernovedad" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">Crear novedad</h4>
        <button type="button" class="close"  aria-label="Close" data-dismiss="modal"><!---->
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" style="margin: 5px;">
          <div class="col-6">
            <div class="row"><b>Razón social</b></div>
            <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="razonsocialfichaind2" [(ngModel)]="Fuente.nombEntidad" disabled/></div>
          </div>
          <div class="col-2">
            <div class="row"><b>NIT</b></div>
            <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="nit2" [(ngModel)]="Fuente.nit" disabled/></div><!---->
          </div>
          <div class="col-2">
            <div class="row"><b>Código entidad</b></div>
            <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="codigoenti2" [(ngModel)]="Fuente.codEnti" disabled/></div><!---->
          </div>
          <div class="col-2">
            <div class="row"><b>Periodo</b></div>
            <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="periodo2" [(ngModel)]="PeriodoModalVer" disabled/></div><!---->
          </div>
        </div>
        <br>
        <div class="container-fluid overflow-scroll">
          <table class="table table-bordered row-border hover datatable" id="tablahist">
            <thead>
              <tr>
                <th scope="col-1" class="text-center">Fecha</th>
                <th scope="col-2" class="text-center">Usuario</th>
                <th scope="col-3" class="text-center">Rol</th>
                <th scope="col-4" class="text-center">Justificación</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let h of HistricoNovedadFuente | paginate:{ itemsPerPage: 6, currentPage: page }">
                <td>{{h.fecha}}</td>
                <td>{{h.usuario}}</td>
                <td>{{h.rol}}</td>
                <td>{{h.justificacion}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row justify-content-end">
          <div class="col-auto"><pagination-controls (pageChange)="page = $event" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls></div>
        </div>
      </div>
      <div class="modal-footer" style="visibility: hidden;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" #closemodalvernovedad>Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="GuardarNovedad()" [disabled]="BtnCrearNov">Crear</button>
      </div>
    </div>
  </div>
</div>
